import { numberSchema, stringSchema, unionSchema, objectSchema } from '@/schemas'

export const invoiceItemSchema = objectSchema({
  id: stringSchema.optional(),
  name: stringSchema.min(1, 'Name is required'),
  quantity: unionSchema([
    numberSchema.min(1, 'Quantity is required'),
    stringSchema.refine(
      val => {
        const num = Number(val)
        return !isNaN(num) && num >= 1
      },
      { error: 'Amount must be at least 1' }
    ),
  ]),
  unit: objectSchema({
    amount: unionSchema([
      numberSchema.min(0.01, 'Amount is required'),
      stringSchema.refine(
        val => {
          const num = Number(val)
          return !isNaN(num) && num >= 0.01
        },
        { error: 'Amount must be at least 0.01' }
      ),
    ]),
  }),
  discount: objectSchema({
    type: stringSchema.optional(),
    value: unionSchema([numberSchema.min(0), stringSchema]).optional(),
  }).optional(),
  source_entity_type: stringSchema.optional(),
})
